if (!customElements.get("story-carousel")) {
  function setupStoryNavButtons(emblaApi, navButtons) {
    const prevBtn = navButtons.querySelector(".embla__prev-button");
    const nextBtn = navButtons.querySelector(".embla__next-button");

    let touchStartTime = 0;
    const togglePrevNextBtnsState = () => {
      const activeSlide = emblaApi.slideNodes()[emblaApi.selectedScrollSnap()];
      const hasActiveVideo =
        activeSlide && activeSlide.dataset.mediaType === "video";

      if (hasActiveVideo) {
        navButtons.style.zIndex = 0;
      } else {
        navButtons.style.zIndex = 1;
      }
    };

    emblaApi
      .on("select", togglePrevNextBtnsState)
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState)
      .on("pointerDown", () => {
        touchStartTime = Date.now();
      });

    const isClick = () => Date.now() - touchStartTime < 250;
    const scrollPrev = () => {
      if (isClick()) {
        emblaApi.scrollPrev();
      }
    };
    const scrollNext = () => {
      if (isClick()) {
        emblaApi.scrollNext();
      }
    };
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    return () => {
      prevBtn.removeEventListener("click", scrollPrev, false);
      nextBtn.removeEventListener("click", scrollNext, false);
    };
  }

  function setupStoryIndicators(dots, embla) {
    const scrollSnaps = embla.scrollSnapList();
    const dotsFrag = document.createDocumentFragment();
    const dotsArray = scrollSnaps.map(() => document.createElement("div"));
    dotsArray.forEach((dotNode) => {
      dotNode.classList.add("embla__dot");
      dotsFrag.appendChild(dotNode);
    });
    dots.appendChild(dotsFrag);

    const setSelectedDotBtn = () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();

      if (dotsArray[previous]) {
        dotsArray[previous].classList.remove("is-selected");
      }
      if (dotsArray[selected]) {
        dotsArray[selected].classList.add("is-selected");
      }
    };

    embla.on("select", setSelectedDotBtn).on("init", setSelectedDotBtn);
  }

  class StoryCarousel extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector(".embla__viewport");
      this.autoplay = EmblaCarouselAutoplay({
        // playOnInit: false,
      });
      this.slider = EmblaCarousel(
        this.viewport,
        {
          loop: true,
          align: "start",
          inViewThreshold: 1,
        },
        [EmblaCarouselClassNames(), this.autoplay]
      );

      this.prevButton = this.querySelector(".embla__prev-button");
      this.nextButton = this.querySelector(".embla__next-button");

      this.navButtons = this.querySelector(".embla__nav-buttons");

      setupStoryNavButtons(this.slider, this.navButtons);

      this.dots = this.querySelector(".embla__dots");
      setupStoryIndicators(this.dots, this.slider);

      this.handleSelect = this.handleSelect.bind(this);
      this.toggleEmblaReady = this.toggleEmblaReady.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.reInitOnResize = debounce(
        () => this.toggleEmblaReady(this.slider, "resize"),
        150
      );

      this.slider
        .on("init", this.toggleEmblaReady)

        .on("reInit", this.toggleEmblaReady)

        .on("init", this.handleSelect)
        .on("select", this.handleSelect)

        .on("reInit", this.handleSelect)
        .on("select", () => this.autoplay.reset())
        .on("resize", this.reInitOnResize)
        .on("init", () => {
          this.slider.internalEngine().translate.toggleActive(false);
          this.slider.internalEngine().translate.clear();
        });

      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.viewport);
    }

    handleSelect() {
      const slidesInView = this.slider.slidesInView(true);
      this.slider.slideNodes().forEach((slide, i) => {
        const video = slide.querySelector("slider-video");
        if (!video) {
          return;
        }
        const inView = slidesInView.includes(i);
        if (inView) {
          video.play();
        } else {
          video.stop();
        }
      });
    }

    toggleEmblaReady(_embla, event) {
      const isResizeEvent = event === "resize";
      const toggleClass = isResizeEvent ? "remove" : "add";
      this.viewport.classList[toggleClass]("embla--is-ready");

      if (isResizeEvent) this.slider.reInit();
    }

    handleResize() {
      this.reInitOnResize();
    }
  }
  customElements.define("story-carousel", StoryCarousel);
}
